export default "__VITE_ASSET__6e6315dc__"